import { render } from "./PlanDiscountLabel.vue?vue&type=template&id=18b3137c&scoped=true"
import script from "./PlanDiscountLabel.vue?vue&type=script&lang=js"
export * from "./PlanDiscountLabel.vue?vue&type=script&lang=js"

import "./PlanDiscountLabel.vue?vue&type=style&index=0&id=18b3137c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b3137c"]])

export default __exports__